import type {MetlTaskBatchPackage} from "../metl-models/task/MetlTaskBatchPackage.ts";
import type {AxiosInstance} from "axios";

export interface MetlTaskHistoryApi {
    id: string
    queryBetween(start: Date, end: Date): Promise<MetlTaskBatchPackage[]>
}

export function taskHistoryApi(axios: AxiosInstance, baseUrl: string, id: string): MetlTaskHistoryApi {
    async function queryBetween(start: Date, end: Date): Promise<MetlTaskBatchPackage[]> {
        //Make a query, which looks like baseUrl/filter/by/end/range/date/<startDate>/time/<startTime>/to/date/<endDate>/time/<endTime>
        // dates are in the format yyyy-mm-dd and times are in the format hh:mm
        const startIsoSplit = start.toISOString().split("T")
        const startDate = startIsoSplit[0]
        const startTime = startIsoSplit[1].split(":")[0] + ":" + startIsoSplit[1].split(":")[1]

        const endIsoSplit = end.toISOString().split("T")
        const endDate = endIsoSplit[0]
        const endTime = endIsoSplit[1].split(":")[0] + ":" + endIsoSplit[1].split(":")[1]

        const url = `${baseUrl}/filter/by/start/range/date/${startDate}/time/${startTime}/to/date/${endDate}/time/${endTime}`
        const response = await axios.get<MetlTaskBatchPackage[]>(url, {
            transformResponse: (data) => {
                return JSON.parse(data, ((key, value) => {
                    //We want to strip the messages from the task packages
                    if (key === "message") {
                        return undefined
                    }
                    return value
                }))
            }
        })
        return response.data
    }
    return {
        id,
        queryBetween
    }
}